import React from 'react';
import { Link, useLocation, useNavigate } from 'react-router-dom';
import { ArrowLeftIcon, BellIcon, FileBadgeIcon, HomeIcon, IdCardIcon, ScrollTextIcon, Trash2Icon, UserRoundIcon, VolleyballIcon } from 'lucide-react';
import { espaceNav, type EspaceNavItem } from '../../data/espace';
import { useEspace } from '../../contexts/EspaceContext';
const icons: Record<EspaceNavItem['icon'], typeof HomeIcon> = {
  home: HomeIcon,
  card: IdCardIcon,
  profile: UserRoundIcon,
  bell: BellIcon,
  trash: Trash2Icon,
  request: ScrollTextIcon,
  ball: VolleyballIcon,
  permit: FileBadgeIcon
};
export function EspaceSidebar() {
  const {
    pathname
  } = useLocation();
  const navigate = useNavigate();
  const {
    exitEspace
  } = useEspace();
  const activeId = espaceNav.find(item => item.to === '/mon-espace' ? pathname === '/mon-espace' : pathname.startsWith(item.to))?.id;
  const leave = () => {
    exitEspace();
    navigate('/');
  };
  return <aside aria-label="Navigation de mon espace" className="hidden w-[268px] shrink-0 flex-col bg-ville-navy lg:flex" data-id="element-1488" data-mp="g3qdbehikptf">
      <div className="px-7 pb-6 pt-8" data-id="element-1489" data-mp="137er347xu7e6">
        <p className="text-lg font-extrabold tracking-tight text-white" data-id="element-1490" data-mp="136d5i5taq2i7">Mon espace</p>
        <p className="mt-1 text-sm text-white/60" data-id="element-1491" data-mp="y93i0vpgw0x0">Votre espace citoyen</p>
      </div>

      <nav className="px-3 pb-8" data-id="element-1492" data-mp="u8b963kiby19">
        <ul data-id="element-1493" data-mp="u92vsow4mlfe">
          {espaceNav.slice(0, 3).map(item => <li key={item.id} data-id="element-1494" data-mp="1qvxpms16r5t2">
              <SidebarLink item={item} active={item.id === activeId} data-id="element-1495" data-mp="1qzd4btqy6cty" />
            </li>)}
        </ul>

        <hr className="my-4 border-white/15" data-id="element-1496" data-mp="1m0iggde4hy2z" />

        <ul data-id="element-1497" data-mp="1h6e75nhdxdyq">
          {espaceNav.slice(3).map(item => <li key={item.id} data-id="element-1498" data-mp="1d640e8lrqjit">
              <SidebarLink item={item} active={item.id === activeId} data-id="element-1499" data-mp="1d4sy6d7z1jtt" />
            </li>)}
        </ul>
      </nav>

      <button type="button" onClick={leave} className="mt-auto flex items-center gap-2 px-7 pb-8 text-sm font-semibold text-white/60 transition-colors duration-150 ease-ville hover:text-white focus:outline-none focus-visible:ring-2 focus-visible:ring-white" data-id="element-1500" data-mp="29pbc08qu23x2">
        <ArrowLeftIcon className="h-4 w-4" aria-hidden="true" data-id="element-1501" data-mp="7x9ms4zoixdn" />
        Quitter mon espace
      </button>
    </aside>;
}
function SidebarLink({
  item,
  active
}: {
  item: EspaceNavItem;
  active: boolean;
}) {
  const Icon = icons[item.icon];
  return <Link to={item.to} aria-current={active ? 'page' : undefined} className={`flex items-center gap-3.5 rounded-xl px-4 py-3 text-[15px] font-semibold transition-colors duration-150 ease-ville focus:outline-none focus-visible:ring-2 focus-visible:ring-white ${active ? 'bg-white/10 text-white' : 'text-white/75 hover:bg-white/5 hover:text-white'}`} data-id="element-1502" data-mp="3genv41oxxdov">
      <Icon className="h-5 w-5 shrink-0" aria-hidden="true" data-id="element-1503" data-mp="14otygdg7mn5p" />
      {item.label}
    </Link>;
}